// extracted by mini-css-extract-plugin
export default {"icon":"header_icon__Ce8SN","header":"header_header__GwvCf","description":"header_description__k1i3Y"};